(function () {
  function initSlider(slider) {
    var track = slider.querySelector('[data-testimonials-track]');
    var prevBtn = slider.querySelector('[data-testimonials-prev]');
    var nextBtn = slider.querySelector('[data-testimonials-next]');
    if (!track) return;

    function cardWidth() {
      var card = track.querySelector('.product-testimonials__card');
      if (!card) return track.clientWidth;
      var style = window.getComputedStyle(card);
      var gap = parseFloat(window.getComputedStyle(track).columnGap || 0);
      return card.getBoundingClientRect().width + gap;
    }

    function scrollByCards(direction) {
      track.scrollBy({ left: cardWidth() * direction, behavior: 'smooth' });
    }

    function updateNavState() {
      if (!prevBtn || !nextBtn) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByCards(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByCards(1);
      });
    }

    track.addEventListener('scroll', updateNavState, { passive: true });
    updateNavState();

    // Autoplay (opcional, configurado desde el editor de la sección)
    var autoplay = slider.getAttribute('data-autoplay') === 'true';
    var speed = parseFloat(slider.getAttribute('data-autoplay-speed') || '5') * 1000;
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (autoplay && !prefersReducedMotion) {
      var timer = null;

      function tick() {
        var maxScroll = track.scrollWidth - track.clientWidth - 2;
        if (track.scrollLeft >= maxScroll) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          scrollByCards(1);
        }
      }

      function start() {
        stop();
        timer = setInterval(tick, speed);
      }

      function stop() {
        if (timer) clearInterval(timer);
      }

      start();
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      slider.addEventListener('touchstart', stop, { passive: true });
      slider.addEventListener('focusin', stop);
      slider.addEventListener('focusout', start);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-testimonials-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();